import React from 'react'
import Link from 'next/link'
import PropTypes from 'prop-types'

export function LinkButton (props) {
  const href = {
    pathname: props.to
  }

  let active = false
  if (props.url && props.url.pathname === props.to) {
    active = true
  }

  if (props.anchor) {
    href.hash = `#${props.anchor}`
  }

  if (props.disabled) {
    return <a className={`${props.className} disabled`}>{props.children}</a>
  } else {
    return (
      <Link href={href}>
        <a className={`${props.className}${active ? ' active' : ''}`} role='button'>
          {props.children}
        </a>
      </Link>
    )
  }
}

LinkButton.propTypes = {
  to: PropTypes.string.isRequired,
  anchor: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string.isRequired,
  disabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  url: PropTypes.object
}
